import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { fetchPipelineHealth } from '../services/api';
import { tokens, type } from '../theme';

const relative = (iso) => {
  if (!iso) return null;
  const then = new Date(iso + (iso.endsWith('Z') ? '' : 'Z'));
  const mins = Math.round((Date.now() - then.getTime()) / 60000);
  if (!Number.isFinite(mins) || mins < 0) return null;
  if (mins < 60) return `${mins} min ago`;
  const hrs = Math.round(mins / 60);
  if (hrs < 24) return `${hrs} hour${hrs === 1 ? '' : 's'} ago`;
  const days = Math.round(hrs / 24);
  return `${days} day${days === 1 ? '' : 's'} ago`;
};

// Scores arrive from a scheduled scrape, not live, so "when was this last checked"
// is genuinely useful — and a stall becomes visible to the reader rather than only
// showing up as rows nobody queries.
const DataFreshness = () => {
  const [health, setHealth] = useState(null);

  useEffect(() => {
    let active = true;
    fetchPipelineHealth().then(d => { if (active) setHealth(d); });
    return () => { active = false; };
  }, []);

  const when = relative(health && (health.completed_at || health.started_at));
  if (!when) return null;

  const stalled = health.status === 'failed' || health.status === 'stale';

  return (
    <Box sx={{ px: 2, py: 1, textAlign: 'center' }}>
      <Typography sx={{
        fontSize: type.label,
        color: stalled ? tokens.loss : tokens.inkFaint,
        fontWeight: stalled ? 600 : 400,
      }}>
        {stalled ? `Scores may be out of date — last checked ${when}` : `Scores updated ${when}`}
      </Typography>
    </Box>
  );
};

export default DataFreshness;
